module.exports = __webpack_public_path__ + "static/img/ae.b62c8ca6.svg";